module.exports = __webpack_public_path__ + "static/media/ab9.c970ebad.png";